import { DefaultError } from '@tanstack/react-query';
import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { emailFormInitialValues } from 'components/organisms/forms/email/EmailForm';
import { useParamId } from 'hooks/useParamId';
import { useTranslation } from 'react-i18next';
import { PiCaretLeftBold, PiPencilSimpleLine } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { PopupActions } from 'reactjs-popup/dist/types';
import { useDeleteEmail, useGetEmail } from 'services/email/email';
import { onErrorShowToast } from 'utils/service/errorHandler';

const Email = () => {
  const emailId = useParamId('/settings/email/');
  const navigate = useNavigate();
  const { data, isLoading } = useGetEmail(emailId);
  const { t } = useTranslation();

  const removeEmail = useDeleteEmail();

  const handleDeleteent = async (actions: PopupActions) => {
    await removeEmail.mutateAsync(emailId, {
      onError: (error: DefaultError) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate(`/settings/email`),
    });
  };

  return (
    <Form.Email
      initialValues={data ? data : emailFormInitialValues}
      onSubmit={() => {}}
      tittle={data?.name}
      status={{ displayMode: true, isLoading }}
      backPath='/settings/email'
      customBackItem={
        <Button
          onlyIcon
          onClick={() => {
            navigate('/settings/email');
          }}>
          <Button.Description description={t('button.back')} />

          <Button.Icon icon={<PiCaretLeftBold />} />
        </Button>
      }
      topbarContent={
        <div className='flex justify-end'>
          {data && !data?.isPredefined && (
            <>
              <Button
                isClear
                onlyIcon
                onClick={() => {
                  navigate(`/settings/email/edit/${emailId}`, {
                    replace: true,
                  });
                }}>
                <Button.Description description={t('button.edit')} />

                <Button.Icon icon={<PiPencilSimpleLine />} />
              </Button>
              <MagellanPopups.DeleteWarning onRemove={handleDeleteent} />
            </>
          )}
        </div>
      }
    />
  );
};

export default Email;
